import { render, staticRenderFns } from "./MessageReplyButton.vue?vue&type=template&id=92e507fa&"
import script from "./MessageReplyButton.vue?vue&type=script&lang=js&"
export * from "./MessageReplyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports